
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 11 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.385.938c.467 0 .846.356.846.795v8.734c0 .439-.38.794-.846.794-.468 0-.847-.355-.847-.794V1.733c0-.439.38-.795.847-.795z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.308 6.1c0-.475.35-.86.78-.86H9.68c.432 0 .781.385.781.86s-.35.86-.78.86H1.088c-.432 0-.781-.385-.781-.86z"}})])
          )
        }
      }
    